import { api } from './api';

export interface SampleLoadResult { factsInserted: number; kpisCreated: number; months: number }
export interface SampleRemoveResult { factsRemoved: number; kpisRemoved: number }

export const sampleDataApi = {
  load: (wsId: string): Promise<SampleLoadResult> =>
    api.post(`/api/workspaces/${wsId}/sample-data`).then((r) => r.data),
  remove: (wsId: string): Promise<SampleRemoveResult> =>
    api.delete(`/api/workspaces/${wsId}/sample-data`).then((r) => r.data),
};
